import { useMemo } from 'react';
import { usePurchasePlanningQuery } from '@/features/purchase-planning/hooks/use-purchase-planning-query';
import { usePurchasePlanningTableColumns } from '@/features/purchase-planning/hooks/use-purchase-planning-table-columns';
import { useDataTable } from '@/hooks/use-data-table';
import type { PurchasePlanning } from '@/types/core/purchase-planning/purchase-planning';
import type { ExtendedColumnSort } from '@/types/data-table';

export const defaultSorting: ExtendedColumnSort<PurchasePlanning>[] = [
  { id: 'supplierId', desc: true },
  { id: 'productId', desc: true },
];

export function usePurchasePlanningTable() {
  const columns = usePurchasePlanningTableColumns();
  const { purchasePlanning, isPending } = usePurchasePlanningQuery();

  const dataTable = useDataTable<PurchasePlanning>({
    data: purchasePlanning.data,
    columns,
    pageCount: purchasePlanning.maxPage,
    initialState: {
      sorting: defaultSorting,
      columnPinning: {
        left: ['productId'],
      },
      columnVisibility: {
        currentStock: false,
        moq: false,
        batchQuantity: false,
        rotationSegment: false,
        averageSalesForecast: false,
        minCoverageQuantity: false,
      },
    },
  });

  const lastVersion = useMemo(
    () => purchasePlanning.data[0]?.createdAt,
    [purchasePlanning.data],
  );

  return {
    ...dataTable,
    isPending,
    lastVersion,
  };
}
